import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Navbar";

export default function Login() {
  const { login, apiError } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Welcome back!"); nav(next); }
    catch (err) { toast.error(apiError(err)); setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <Logo />
          <h1 className="font-heading font-bold text-3xl tracking-tight text-[#09090b] mt-10">Welcome back</h1>
          <p className="font-body text-sm text-[#52525b] mt-2">Log in to manage your websites.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="ml-label">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-2 border border-border rounded-xl px-4 py-3 font-body text-sm outline-none focus:ring-2 focus:ring-sky-400" />
            </div>
            <div>
              <label className="ml-label">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-2 border border-border rounded-xl px-4 py-3 font-body text-sm outline-none focus:ring-2 focus:ring-sky-400" />
            </div>
            <button data-testid="login-submit" disabled={loading} className="w-full ml-ai-btn rounded-full py-3 font-semibold text-sm font-body inline-flex items-center justify-center gap-2">
              {loading && <Loader2 size={16} className="animate-spin" />} Log in
            </button>
          </form>
          <p className="font-body text-sm text-[#52525b] mt-6">No account? <Link to="/register" className="font-semibold text-[#09090b]" data-testid="to-register">Sign up free</Link></p>
        </div>
      </div>
      <div className="hidden lg:block bg-[#09090b] ml-grid-bg" />
    </div>
  );
}
